export enum shelfStatuses {
  public = 0,
  private = 10,
  loaned = 20,
  borrowed = 30,
  library = 40
}